import React from 'react'

const SvgMedicineExclamation = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M12.934 7.994H3v11.99c0 1.331.667 1.997 2 1.997l2.302.007a3.423 3.423 0 01.072-2.961l5.56-11.033zM2 6V3.998C2 2.666 2.68 2 4.038 2H20c1.333 0 2 .666 2 1.998V6H2zM19.066 7.994L21 11.832V7.994h-1.934z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M21 16.254l-3.768-7.476a1.375 1.375 0 00-2.464 0L9.14 19.943c-.471.935.198 2.044 1.232 2.044h8.261L19 21.98c1.333-.025 2-.69 2-1.998v-3.729zm-4.762-5.027c.41.14.706.534.706.998v3.51a1.041 1.041 0 01-1.038 1.053 1.041 1.041 0 01-1.037-1.053v-3.51a1.048 1.048 0 011.037-1.053c.116 0 .228.02.332.055zm-.332 6.615c.515 0 .964.285 1.203.708.115.205.181.442.181.696 0 .266-.073.515-.2.727a1.38 1.38 0 01-1.184.677c-.501 0-.94-.271-1.183-.677a1.412 1.412 0 01-.2-.727c0-.254.066-.491.181-.696a1.38 1.38 0 011.202-.708z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.153 19.953L14.77 8.766a1.37 1.37 0 012.46 0l5.617 11.187c.47.936-.198 2.047-1.23 2.047H10.383c-1.032 0-1.7-1.111-1.23-2.047zm5.372-.7c0-.776.619-1.406 1.381-1.406.763 0 1.382.63 1.382 1.407s-.619 1.406-1.382 1.406c-.762 0-1.38-.63-1.38-1.406zm2.417-7.033c0-.583-.463-1.055-1.036-1.055-.572 0-1.035.473-1.035 1.055v3.517c0 .583.463 1.055 1.035 1.055.573 0 1.036-.472 1.036-1.055V12.22z'
    />
  </svg>
)

export default SvgMedicineExclamation
